import React from "react"
import Form from "semantic-ui-react/dist/es/collections/Form/Form"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import "./Worksheet.css"
import WorksheetBody from "./WorksheetBody"
import WorksheetDivider from "./WorksheetDivider"
import WorksheetField from "./WorksheetField"
import WorksheetFieldGroup from "./WorksheetFieldGroup"
import WorksheetFooter from "./WorksheetFooter"
import WorksheetHeader from "./WorksheetHeader"
import WorksheetRow from "./WorksheetRow"
import WorksheetRowCollection from "./WorksheetRowCollection"

const Worksheet = ({ error, pending, children, ...rest }) => {
  return (
    <Form error={!!error} loading={pending} {...rest}>
      <Grid>{children}</Grid>
    </Form>
  )
}

Worksheet.Header = WorksheetHeader
Worksheet.Body = WorksheetBody
Worksheet.Divider = WorksheetDivider
Worksheet.Footer = WorksheetFooter
Worksheet.Row = WorksheetRow
Worksheet.FieldGroup = WorksheetFieldGroup
Worksheet.Field = WorksheetField
Worksheet.RowCollection = WorksheetRowCollection
export default Worksheet
